import { Service } from "./Service";

// src/models/Doctor.js
export class Doctor {
    constructor(data) {
      Object.assign(this, {
        id: data.id,
        first_name: data.first_name,
        last_name: data.last_name,
        name: `${data.first_name} ${data.last_name}`,
        email: data.email,
        phone: data.phone || '',
        address: data.address,
        register_data: data.register_data,
        login_enabled: data.login_enabled,
        specialization: data.specialization,
        profile_picture: data.profile_picture,
        tags: data.tags || [],
        services: (data.services || []).map(service => new Service(service)),
        default_price_hour: data.default_price_hour,
        office_address: data.office_address,
        biography: data.biography,
        professional_story: data.professional_story,
        average_feedback: data.average_feedback,
        time_preferences: data.time_preferences || {}
      });
    }
  }